import { Component } from '@angular/core';

@Component({
  selector: 'app-nomobileuse',
  standalone: false,
  
  templateUrl: './nomobileuse.component.html',
  styleUrl: './nomobileuse.component.scss'
})
export class NomobileuseComponent {

}
